import React from "react";
import { useTranslation } from "react-i18next";
import Card from "../../Components/Card/card";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Slider from "react-slick";
import Eventcard from "../../Newdesign/popularevents/eventcard";
import { useRef, useState, useEffect } from "react";
const UpcomingEvents = ({ upcomingEvents }) => {
  const { t } = useTranslation();
  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <MdKeyboardArrowLeft
        className={className}
        style={{
          ...style,
          color: "#483f50",
          height: "55px",
          width: "55px",
          backgroundColor: "white",
          borderRadius: "50%",
        }}
        onClick={onClick}
      />
    );
  };
  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <MdKeyboardArrowRight
        className={className}
        style={{
          ...style,
          color: "#483f50",
          height: "55px",
          width: "55px",
          backgroundColor: "white",
          borderRadius: "50%",
        }}
        onClick={onClick}
      />
    );
  };
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: upcomingEvents?.length > 2 ? 3 : upcomingEvents?.length,
    slidesToScroll: 1,
    initialSlide: 1,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
  };

  const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
  
    useEffect(() => {
      const handleMouseUp = () => {
        setIsDragging(false);
      };
  
      const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 3;
        scrollRef.current.scrollLeft = scrollLeft - walk;
      };
  
      const handleTouchMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 3;
        scrollRef.current.scrollLeft = scrollLeft - walk;
      };
  
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.addEventListener("touchmove", handleTouchMove);
      document.addEventListener("touchend", handleMouseUp);
  
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleMouseUp);
      };
    }, [isDragging, startX, scrollLeft]);
  
    const handleMouseDown = (e) => {
      setIsDragging(true);
      setStartX(e.pageX - scrollRef.current.offsetLeft);
      setScrollLeft(scrollRef.current.scrollLeft);
    };
  
    const handleTouchStart = (e) => {
      setIsDragging(true);
      setStartX(e.touches[0].pageX - scrollRef.current.offsetLeft);
      setScrollLeft(scrollRef.current.scrollLeft);
    };
  return (
    <div className="-mx-20 md:mx-auto font-poppins bg-[#FFBEBE]" style={{ height: "590px" }}>
          <div className="bg-[#FFBEBE]">
            <h1 className="mb-3 text-xl font-bold md:text-3xl mt-14 ml-28 ">{t("Upcomming Events")}</h1>
            {Array.isArray(upcomingEvents) && upcomingEvents.length > 0 ? (
              <div className="relative">
                <div className="absolute top-0 left-0 h-full bg-[#FFBEBE]" style={{ width: "110px"}}></div>
                <div
                  className={`overflow-x-auto pl-28 ${upcomingEvents.length >= 4 ? 'custom-scroll' : ''}`}
                  ref={scrollRef}
                  onMouseDown={upcomingEvents.length >= 4 ? handleMouseDown : null}
                  onTouchStart={upcomingEvents.length >= 4 ? handleTouchStart : null}
                  style={{ cursor: isDragging ? "grabbing" : "grab", overflowY: "hidden" }}
                >
                  <div className="flex w-full gap-4">
                    {upcomingEvents.map((event, index) => (
                      <div key={index} className="inline-block">
                        <Eventcard event={event} index={index} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <span className="block text-lg font-semibold text-center">
                There is no Upcomming Event Right Now
              </span>
            )}
          </div>
        </div>
  );
};

export default UpcomingEvents;
